import React, { MouseEvent, useCallback, useEffect, useRef } from "react";
import { DiseaseKnowledgeListDialog } from "./components/list/DiseaseKnowledgeListDialog";
import { DiseaseKnowledgeDetailDialog } from "./components/detail/DiseaseKnowledgeDetailDialog";
import { Modal } from "./DiseaseKnowledgeModal";
import { useSelector } from "react-redux";
import { State, useAppDispatch } from "../../../state/store";
import { CloseIcon } from "./icons/CloseIcon";
import { clearKeywordAction, closeDialogAction } from "../../../state/usecase/disease_knowledge/actions";
import { DiseaseKnowledgeSearchResultDialog } from "./components/search_result/DiseaseKnowledgeSearchResultDialog";

export const DiseaseKnowledgeDialog = React.memo(function DiseaseKnowledgeDialog() {
    const dispatch = useAppDispatch();

    const dialogMode = useSelector((state: State) => state.diseaseKnowledge.dialogMode);

    const onClickContainer = useCallback((event: MouseEvent<any>) => event.stopPropagation(), []);

    const onRequestClose = useCallback(() => {
        dispatch(clearKeywordAction());
        dispatch(closeDialogAction());
    }, [dispatch]);

    const dialogContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!dialogMode) return;

        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "";
        };
    }, [dialogMode]);

    if (!dialogMode) return null;

    return (
        <Modal open={dialogMode !== null} onRequestClose={onRequestClose}>
            <div className={"disease_dialog"}>
                <div className={"container"} onClick={onClickContainer} ref={dialogContainerRef}>
                    {dialogMode === "list" ? (
                        <DiseaseKnowledgeListDialog />
                    ) : dialogMode === "searchResult" ? (
                        <DiseaseKnowledgeSearchResultDialog />
                    ) : (
                        <DiseaseKnowledgeDetailDialog diseaseId={dialogMode.diseaseId} dialogContainerRef={dialogContainerRef} />
                    )}
                    <button className={"close_button"} onClick={onRequestClose}>
                        <CloseIcon />
                    </button>
                </div>
            </div>
        </Modal>
    );
});
